// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeDeviceUnregisterBody = {
  expoPushToken: string;
};

export type typeDeviceUnregisterOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isRemoved: boolean };
};

export type typeDeviceUnregisterOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeDeviceUnregisterOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeDeviceUnregisterOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaDeviceUnregisterBody = {
  type: "object",
  properties: {
    expoPushToken: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["expoPushToken"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createDeviceUnregister(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaDeviceUnregisterBody);
  }

  return async function postDeviceUnregister(
    payload: typeDeviceUnregisterBody,
  ): Promise<typeDeviceUnregisterOutput200 | typeDeviceUnregisterOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postDeviceUnregister" failed before calling the network. #75f924609438`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#75f924609438" },
        },
        data: null,
      } as typeDeviceUnregisterOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/device/unregister`,
      httpMethod: "POST",
      options,
    })) as typeDeviceUnregisterOutput200 | typeDeviceUnregisterOutput400;
  };
}
